import { useState, useEffect } from 'react'
import { NavLink, useLocation } from "react-router";
import { Clock} from 'lucide-react';
import Logout from './Logout';

function Navbar() {

  const [mobileNavVisible, setMobileNavVisible] = useState(false)
  const {pathname} = useLocation();
  useEffect(() => {
    setMobileNavVisible(false)
  }, [ pathname ]);

  return (
    <>

     <nav className="relative bg-white/10 backdrop-blur-lg rounded-3xl shadow-2xl p-4 mb-6">
        <div className="px-2 sm:p-6 lg:p-2">
          <div className="relative flex h-12 items-center justify-between">
            <div className="absolute inset-y-0 right-0 flex items-center sm:hidden">
              <button type="button" onClick={()=>setMobileNavVisible(!mobileNavVisible)} className="relative inline-flex items-center justify-center rounded-md p-2 text-gray-800 hover:text-black/20 focus:outline-2 focus:-outline-offset-1 focus:outline-indigo-500">
                <span className="absolute -inset-0.5"></span>
                <span className="sr-only">Open main menu</span>
                {
                  !mobileNavVisible &&
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" data-slot="icon" aria-hidden="true" className="size-8 ">
                      <path d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  }
                {
                  mobileNavVisible &&
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" data-slot="icon" aria-hidden="true" className="size-8 ">
                    <path d="M6 18 18 6M6 6l12 12" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                }
              </button>
            </div>
            <div className="flex flex-1  sm:items-stretch sm:justify-start">
              <div className="flex shrink-0 items-center">
                <NavLink to="/" end className="block cursor-pointer ">
                  <h1 className="flex items-center justify-center gap-3 text-2xl mb-2 font-bold  ">
                    <Clock className="w-10 h-10" />
                    <span className="hidden sm:inline">Project Man</span>
                  </h1>

                </NavLink>
              </div>
            </div>
            <div className="hidden sm:ml-6 sm:block">
                <div className="flex space-x-4 items-center">
                  <NavLink to="/projects" end className="rounded-md hover:bg-gray-200 px-3 py-2 text-lg font-medium">Projects</NavLink>
                  <NavLink className="rounded-md hover:bg-gray-200 px-3 py-2 text-lg font-medium"><Logout /></NavLink>

                </div>

            </div>
          </div>
        </div>
        {
          mobileNavVisible &&
            <el-disclosure id="mobile-menu" className="block sm:hidden">
              <div className="space-y-1 px-2 pt-2 pb-3 text-center">
                  <NavLink to="/projects" end className="block rounded-md hover:bg-gray-200 px-3 py-2 text-lg font-medium">Projects</NavLink>
                  <NavLink className="block rounded-md hover:bg-gray-200 px-3 py-2 text-lg font-medium"><Logout /></NavLink>
              </div>
            </el-disclosure>
        }
      </nav>    




    </>
  )
}

export default Navbar
